var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAxisBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1500,
    height: 800,
    viewBox: "0 0 1440 1119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6984_34142)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1119,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.167 787.97C207.967 866.225 36 745.696 0 680.484V1119H1440V0H1171.67C1109.17 56.2354 1077.45 136.894 1094.67 217.552C1124.17 355.749 972.5 538.874 843.5 527.5C714.5 516.126 691.147 421.349 550 479.728C434.5 527.5 507.667 690.151 341.167 787.97Z",
    fill: "#FFF8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.154 981.5C669.68 970.126 636.647 875.349 436.99 933.728C332.654 964.236 337.158 1041.59 292.699 1119H1440V393.37C1297.86 419.268 1241.53 483.252 1207.44 671.552C1181.71 813.601 1034.63 992.874 852.154 981.5Z",
    fill: "#FFF1CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6984_34142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1119,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxisBg);
export default __webpack_public_path__ + "static/media/AxisBg.7a0275b11581fe0d4435d737a7b8ed24.svg";
export { ForwardRef as ReactComponent };